// Generated file - do not change manually!

/**
 * Defines different types of MessageStrip.
 */
export enum MessageStripDesign {
  /**
   * Message should be just an information
   */
  Information = 'Information',

  /**
   * Message is an error
   */
  Negative = 'Negative',

  /**
   * Message is a success message
   */
  Positive = 'Positive',

  /**
   * Message is a warning
   */
  Warning = 'Warning'
}
